export default {
  // to: ["mytracker-index"],
  logoSrc: "/assets/img/black/logo.svg",
  title: [
    { text: "BEAUTY", color: "#ec2027" },
    { text: "PRO", color: "" }
  ],
  links(group, siteId) {
    const executiveReports = (group || {}).options.includes(
      "user.mytracker.executiveReporting"
    )
      ? [
          {
            icon: "file",
            title: "Executive Reports",
            to: ["mytracker-reports"],
            links: false
          },
          {
            icon: "arrowDownToLine",
            title: "Saved Reports",
            to: ["mytracker-saved"],
            links: false
          }
        ]
      : [];

    return [
      // {
      //   icon: 'home',
      //   title: 'Home',
      //   to: ['home'],
      //   links: false,
      // },
      // {
      //   icon: 'star',
      //   title: 'POE',
      //   index: 'poe-index',
      //   to: null,
      //   links: [
      //     {
      //       icon: 'home',
      //       title: 'How It Works',
      //       to: ['poe-index'],
      //       links: false,
      //     },
      //     {
      //       icon: '',
      //       title: 'Dashboard',
      //       to: ['poe-dashboard'],
      //       links: false,
      //     },
      //     {
      //       icon: '',
      //       title: 'Performance',
      //       to: ['poe-performance'],
      //       links: false,
      //     },
      //     {
      //       icon: '',
      //       title: 'Incentives',
      //       to: ['poe-incentives'],
      //       links: false,
      //     },
      //     {
      //       icon: '',
      //       title: 'Leaderboard',
      //       to: ['poe-leaderboard'],
      //       links: false,
      //     },
      //     {
      //       icon: '',
      //       title: 'Expense Report',
      //       to: ['poe-expenses'],
      //       links: false,
      //     },
      //   ],
      // },
      {
        icon: "scissors",
        title: "Salon DB",
        index: "salondb-index",
        to: null, // #['salondb'],
        links: [
          {
            icon: "home",
            title: "Salon Search",
            to: ["salondb-index"],
            links: false
          },
          {
            icon: "products",
            title: "Loyalty Orders",
            to: ["salondb-orders"],
            links: false
          },
          {
            icon: "expenses",
            title: "Loyalty Points",
            to: ["salondb-points"],
            links: false
          }
        ]
      },
      ...(((group || {}).modules || []).includes("mytracker")
        ? [
            {
              icon: "chartLineUp",
              title: "My Tracker",
              index: "mytracker-index",
              to: null,
              links: [
                {
                  icon: "home",
                  title: "Sales Dashboard",
                  to: ["mytracker-index"],
                  links: false
                },
                ...((group || {}).options.includes(
                  "user.mytracker.loyaltyDashboard"
                )
                  ? [
                      {
                        icon: "home",
                        title: "ClubH Dashboard",
                        to: ["mytracker-loyalty-dashboard"],
                        links: false
                      }
                    ]
                  : []),
                {
                  icon: "chartLineUp",
                  title: "KPI Tracker",
                  to: ["mytracker-kpis"],
                  links: false
                },
                ...executiveReports
              ]
            }
          ]
        : []),
      ...(((group || {}).modules || []).includes("filevault")
        ? [
            {
              icon: "folder",
              title: "Filevault",
              index: "filevault-index",
              to: null,
              links: [
                {
                  icon: "home",
                  title: "All Files",
                  to: ["filevault-index"],
                  links: false
                },
                {
                  icon: "chartLineUp",
                  title: "All Tags",
                  to: ["filevault-tags"],
                  links: false
                },
                {
                  icon: "chartLineUp",
                  title: "My Collections",
                  to: ["filevault-collections"],
                  links: false
                }
              ]
            }
          ]
        : []),
      ...(((group || {}).modules || []).includes("etl")
        ? [
            {
              icon: "arrowUpToLineSolid",
              title: "ETL",
              to: ["etl"],
              links: false
            }
          ]
        : [])
    ];
  }
};



// WEBPACK FOOTER //
// ./src/configs/sidebar/beautyerp.js